<!-- Vertical layout -->
@if (isVerticalLayoutRequested()) {
    <app-vertical></app-vertical>
}

<!-- @if (isHorizontalLayoutRequested()) {
    <app-horizontal></app-horizontal>
} -->